import "./formatters.css";

export const formatClassification = (value, classifierModel) => {
    if (!value) return "";
    var toAppend = "";
    if (classifierModel === undefined || classifierModel === null) {
        toAppend = "";
    } else {
        if (classifierModel.id === "newClassifierModel") {
            toAppend = "";
        } else {
            toAppend = toAppend + "*";
        }
    }

    switch (value.toLowerCase()) {
        case "red":
            return <span className="classificationRed">{value + toAppend}</span>;
        case "yellow":
            return <span className="classificationYellow">{value + toAppend}</span>;
        case "green":
            return <span className="classificationGreen">{value + toAppend}</span>;
        case "poor":
            return <span className="classificationRed">{value + toAppend}</span>;
        case "fair":
            return <span className="classificationYellow">{value + toAppend}</span>;
        case "good":
            return <span className="classificationGreen">{value + toAppend}</span>;
        default:
            return value;
    }
};